import { useDropzone } from "react-dropzone";

import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, SxProps, Theme, createStyles, useTheme } from "@mui/material";
// import makeStyles from "@mui/styles";

import { FormikErrors, useField } from "formik";

import { Translate } from "@/components/Application/Translate";

type Props = {
  label?: string;
  name: string;
  id: string;
  type: string;
  placeholder?: string;
  translationString: string;
  setFieldValue: (
    field: string,
    value: any,
    shouldVaidate?: boolean,
  ) => Promise<void | FormikErrors<{
    ProcedureId: number;
    SchemeId: number;
    File: null;
    FileName: null;
  }>>;
};

const useStyles = (theme: Theme): { [key: string]: SxProps } =>
  createStyles({
    dropzone: {
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      alignItems: "center",
      border: "2px dashed #676d71",
      borderRadius: "4px",
      padding: "2rem",
      textAlign: "center",
      cursor: "pointer",
      width: "100%",
      height: "100%",
      transition: "border 0.3s ease-in-out",
      "&.active": {
        border: "2px dashed #00c853",
      },
    },
    fileInfo: {
      marginTop: "1rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      p: {
        display: "inline-block",
        marign: 0,
        marginRight: "1rem",
      },
    },
  });

const CustomDropZoneUpload = ({
  setFieldValue,
  label,
  translationString,
  ...props
}: Props) => {
  const [field, meta, helpers] = useField(props.name);
  const theme = useTheme();
  const classes = useStyles(theme);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      setFieldValue("File", acceptedFiles[0]);
      setFieldValue("FileName", acceptedFiles[0].name);
    },
  });

  return (
    <Box
      {...getRootProps({
        className: `${classes.dropzone} ${isDragActive ? "active" : ""}`,
        sx: {...classes.dropzone, ...(isDragActive && { border: "2px dashed #00c853" })},
      })}
    >
      <input {...props} accept="application/msword" {...getInputProps()} />
      {isDragActive ? (
        <Translate HTMLTag="label" String={translationString + ".hover"}>
          Drop the files here ...
        </Translate>
      ) : (
        <>
          <Translate HTMLTag="label" String={translationString}>
            Drag 'n' drop some files here, or click <u>here</u> to select files
          </Translate>
          {field.value && (
            <Box sx={classes.fileInfo}>
              <Translate HTMLTag="p" String="FileUpload.File">
                File:
              </Translate>
              <p>{field.value.name || field.value.FileName}</p>
              <Button
                color="error"
                onClick={(e) => {
                  e.stopPropagation();
                  setFieldValue("File", null);
                }}
                style={{ marginLeft: "10px" }}
              >
                <DeleteIcon />
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default CustomDropZoneUpload;
